<template>
  <div class="results" :class="guest ? 'container':''">
    <h2 class="profile__header header">
      <div>{{ $t('diagnostic.header') }}</div>
      <span v-if="selectedDiagnostic" class="diagnostic">
                {{ selectedDiagnostic.title }}
            </span>

      <span v-if="selectedDiagnosticType" class="diagnostic-type">
                 {{ $t('diagnostic.kind') }}: {{ selectedDiagnosticType.title }}
            </span>

      <span v-if="selectedClinic" class="clinic">
                {{ selectedClinic.short_title }}
            </span>

      <router-link class="icon__edit" :to="routerLinkOrderChooseDiagnostic"></router-link>
    </h2>

    <div class="row">
      <div class="col-8">
        <div v-if="loading">
          <div class="col-6 offset-6">
            <!-- Preloader -->
            <div class="circonf-wrapper">
              <div class="circonf circonf-1">
              </div>
              <p>{{ $t('common.query_in_process') }}</p>
              <p>{{ $t('common.not_reload_page') }}</p>
            </div>
          </div>
        </div>

        <div class="mb-3" v-if="!loading && time_table_groups.length === 0">
          {{ $t('consultations.seance_not_found') }}
        </div>

        <template
            v-if="!loading && selectedDiagnosticType && selectedDiagnosticType.can_choose_doctor && doctor_groups && doctor_groups.length > 0">
          <p>{{ $t('diagnostic.choose_doctor') }}</p>

          <select class="form-control mb-3" v-model="selected_doctor_id" @change="onDoctorIdSelect">
            <option v-for="doctor in doctor_groups" :value="doctor.id">
              {{ doctor.name }}
            </option>
          </select>
        </template>

        <div v-if="!loading && time_table_groups.length !== 0">
          <time-table-input v-if="time_table_groups && clinics"
                            :time_table_groups="getTimeTableByDoctor(selected_doctor_id)"
                            :clinics="clinics"
                            :choose-clinic="selectedClinic == null"
                            ref="timeTableInput"
                            @input="onSelectTimeTable"></time-table-input>
          <div v-if="seanceLoading" class="text-center mt-5 d-flex justify-content-center">
            <b-spinner
                variant="primary"
            ></b-spinner>
          </div>
          <button class="btn btn-inline pull-right"
                  v-if="!seanceLoading"
                  :disabled="disableConfirmButton"
                  @click="openInfoModal">
            <!--                  @click="openConfirmationModal">-->
            {{ $t('buttons.confirm') }}
          </button>
          <div class="mt-3">
          </div>
        </div>
      </div>

      <div class="col-4" v-if="!loading">
        <div class="doctor-not-found-card card">
          <span class="header">{{ $t('consultations.not_found_card_timetable.header') }}</span>

          <span class="text">{{ $t('consultations.not_found_card_timetable.text') }}</span>

          <span class="phone">+38 (048) 730-00-30</span>
        </div>
      </div>
    </div>

    <b-modal ref="confirmationModal" centered hide-footer :title="$t('common.check_data')"
             @hide="rollbackPrepareInfoAgree">
      <div v-if="selectedDiagnosticType" class="diagnostic-type">
        <b>{{ $t('diagnostic.kind') }}:</b> {{ selectedDiagnosticType.title }}
      </div>

      <div v-if="selectedDiagnostic" class="doctor mt-1">
        {{ selectedDiagnostic.name }}
      </div>

      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.department') }}:</b> {{ selectedClinic.title }}
      </div>
      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.address') }}:</b> {{ selectedClinic.address }}
      </div>

      <div v-if="selected_time_table" class="mt-1">
        <b>{{ $t('consultations.seance_time') }}:</b> {{ formatTime(selected_time_table.start_time, 'D MMM YYYY') }}
        {{ $t('consultations.from') }} {{ formatTime(selected_time_table.start_time, 'HH:mm') }}
        {{ $t('consultations.to') }} {{ formatTime(selected_time_table.end_time, 'HH:mm') }}
      </div>

      <div v-if="selected_time_table_info" class="mt-1">
        <b>{{ $t('consultations.seance_amount') }}:</b> {{ selected_time_table_info.price }} грн.
      </div>

      <div v-if="selected_time_table_info && !selected_time_table_info.available" class="mt-1">
        <b>{{ $t('errors.seance_busy') }}</b>
      </div>
      <template v-else>
        <template v-if="!guest">
          <div class="my-3 text-center d-flex justify-content-center" v-if="paymentLoading">
            <b-spinner
                variant="primary"
            ></b-spinner>
          </div>
          <div class="mt-3" v-if="selected_time_table_info && !paymentLoading">
            <button class="btn text-white btn-font-default pt-3" style="line-height: 14px;"
                    :disabled="!selected_time_table_info.available" @click="orderDiagnosticTimeTable">
              {{ $t('buttons.pay_seance') }}
              <br>
              <br>
              <p style="font-weight: normal;font-size: 12px;">
                <span class="text-danger">*</span> {{ $t('common.pay_warning') }}
              </p>
            </button>
          </div>
          <div class="mt-1" v-if="selected_time_table_info && !paymentLoading">
            <div v-if="isReservation.reservation">
              <button class="btn btn-blue-sky btn-font-default py-2" @click="makeReservation">
                {{ $t('buttons.reserve') }}
              </button>
              <b-form-checkbox
                  name="noNeedCheckbox"
                  unchecked-value="not_accepted"
                  v-model="noNeedCheckbox"
              >
                {{ $t('common.not_callback') }}
              </b-form-checkbox>
            </div>
            <div v-if="isReservation.operatorCall">
              <button class="btn btn-blue-sky btn-font-default" @click="callOperator">
                {{ $t('common.operator_call') }}
              </button>
            </div>

          </div>
        </template>
        <template v-else>
          <div class="mt-3" v-if="selected_time_table_info">
            <button class="btn" :disabled="!selected_time_table_info.available" @click="orderGuest">
              {{ $t('buttons.confirm') }}
            </button>
          </div>
        </template>
      </template>
      <div v-if="selected_time_table_info" class="mt-1 text-center">
        <button class="btn btn-link btn-link-clear" @click="cancelTimeTable">
          <template v-if="selected_time_table_info.available">{{ $t('buttons.hide') }}</template>
          <template v-else>{{ $t('buttons.cancel') }}</template>
        </button>
      </div>
    </b-modal>

    <operator-modal :show="showOperatorModal"/>
    <prepare-info-modal
        :show="showPrepareInfoModal"
        :time_table_info="selected_time_table_info"
        :selected_specialization="selectedDiagnostic"
        @closePrepareModal="closeInfoModal"

    />
    <b-modal ref="successModal" centered hide-footer :title="patient.name">
      <div v-if="selectedDiagnostic" class="specialization">
        <b>{{ $t('diagnostic.type') }}:</b> {{ selectedDiagnostic.title }}
      </div>

      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.department') }}:</b> {{ selectedClinic.title }}
      </div>
      <div v-if="selectedClinic" class="clinic mt-1">
        <b>{{ $t('consultations.address') }}:</b> {{ selectedClinic.address }}
      </div>
      <div v-if="selected_time_table" class="mt-1">
        <b>{{ $t('consultations.seance_time') }}:</b> {{ formatTime(selected_time_table.start_time, 'D MMM YYYY') }}
        &nbsp;{{ formatTime(selected_time_table.start_time, 'HH:mm') }}
      </div>

      <div v-if="selected_time_table_info" class="mt-1">
        <b> {{ $t('consultations.seance_amount') }}:</b> {{ selected_time_table_info.price }} грн.
      </div>
      <div class="mt-1 d-flex justify-content-center">
        <button class="btn btn-link btn-link-clear" @click="closeSuccessModal">{{ $t('buttons.hide') }}</button>
      </div>

    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import config from '@/helpers/configDateFormats';
import TimeTableInput from '@/components/TimeTableInput'
import { mapGetters } from "vuex";
import OperatorModal from "@/components/operatorModal";
import PrepareInfoModal from "@/components/prepareInfoModal";
import getSettings from "@/api/settings/getSettings";

export default {
  name: 'order-choose-diagnostic-time-table',
  props: {
    diagnostic_id: {
      required: true,
      type: [Number, String],
    },
    diagnostic_type_id: {
      required: true,
      type: [Number, String],
    },
    clinic_id: {
      required: false,
      type: [Number, String],
    },
    guest: {
      default: false,
      required: false,
      type: [Boolean],
    },
  },
  data() {
    return {
      selectedDiagnostic: null,
      selectedDiagnosticType: null,
      selectedClinic: null,

      selected_time_table: null,
      selected_time_table_info: null,

      doctor_groups: [],
      selected_doctor_id: null,

      time_table_groups: [],

      loading: true,
      seanceLoading: false,
      paymentLoading: false,

      agreeWithPrepareInfo: false,

      noNeedCheckbox: true,

      showOperatorModal: false,
      showPrepareInfoModal: false
    }
  },
  watch: {
    agreeWithPrepareInfo(newValue) {
      if (newValue === true) {
        this.openConfirmationModal();
      }
    }
  },
  methods: {
    /** UI methods **/
    closeInfoModal(agree) {
      this.showPrepareInfoModal = false
      this.seanceLoading = false
      this.agreeWithPrepareInfo = agree
    },
    openInfoModal() {
      if (this.selected_time_table_info?.service_prepare_info_id) {
        this.showPrepareInfoModal = true
      } else {
        this.closeInfoModal(true);
      }
    },

    onDoctorIdSelect() {
      this.selected_time_table = null;
      this.$refs.timeTableInput.setSelectedTimeTable(this.selected_time_table);
    },
    openSuccessModal() {
      this.$refs.successModal.show()
    },
    closeSuccessModal() {
      this.$refs.successModal.hide()
    },
    openOperatorModal() {
      this.showOperatorModal = true;
    },

    closeConfirmationModal() {
      this.$refs.confirmationModal.hide();
    },
    openConfirmationModal() {
      this.$refs.confirmationModal.show();
    },
    cancelTimeTable() {
      this.closeConfirmationModal()
    },
    rollbackPrepareInfoAgree() {
      this.agreeWithPrepareInfo = false;
    },

    /** Helper methods**/
    formatTime(date, format = 'HH:mm') {
      return moment(date).format(format);
    },

    orderGuest() {
      this.$router.push({
        name: 'order.guest',
        query: {
          type: 'diagnostic',
          service_id: this.selectedDiagnostic.id,
          time_table_id: this.selected_time_table.id,
        },
      });
    },
    moveToPaymentPage(data) {
      let params = data;
      let url = params.url

      this.closeConfirmationModal()
      let newWindow = window.open() // метод позволяет открыть новое окно браузера
      let newWindowDocument = newWindow.document; // ссылаемся на объект document в новом открытом окне
      // открываем поток для записи документа
      newWindowDocument.open("text/html", "replace");
      // используем метод write
      newWindowDocument.write(data);

      newWindowDocument.close();
      this.$router.push({name: 'profile'})
    },

    /** Make order methods **/
    callOperator() {
      this.$store
          .dispatch('orderDoctorTimeTable', {
            timetable_id: this.selected_time_table.id,
            service_id: this.selected_time_table.service_id,
            pay: 0,
            reserve: 1,
            need_callback: 1
          })
          .then(order_info => {
            this.closeConfirmationModal()

            this.openOperatorModal()

            this.fetch();

            this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']});

            this.$store
                .dispatch('getUserInfo');
          });
    },
    makeReservation() {
      this.paymentLoading = true
      this.$store
          .dispatch('orderDoctorTimeTable', {
            timetable_id: this.selected_time_table.id,
            service_id: this.selected_time_table.service_id,
            pay: 1,
            reserve: 0,
            need_callback: +!this.noNeedCheckbox,
          })
          .then(response => {
            this.paymentLoading = false
            if (response.status === 'Busy') {
              this.selected_time_table_info.available = false
              return false
            }
            this.fetch()
            this.closeConfirmationModal()
            this.openSuccessModal()
          });
    },
    orderDiagnosticTimeTable() {
      this.paymentLoading = true
      this.$store
          .dispatch('orderDoctorTimeTable', {
            timetable_id: this.selected_time_table.id,
            service_id: this.selected_time_table.service_id,
            pay: 1,
            reserve: 0,
            need_callback: 1,
          })
          .then(response => {
            if (response.status === 'Busy') {
              //todo show busy Modal
              this.selected_time_table_info.available = false
              this.paymentLoading = false
              return
            }
            this.$store.dispatch('getPaymentLink', {visit_id: response.id}).then(response => {
              this.paymentLoading = false
              this.moveToPaymentPage(response)

              this.fetch()

              this.$store.dispatch('getVisits', {serviceTypes: ['diagnostic', 'specialization', 'otherService']});

              this.$store
                  .dispatch('getUserInfo');

              this.openSuccessModal()
            })
          });
    },
    async onSelectTimeTable(timeTable, showPrepareInfo = true) {
      this.selected_time_table = timeTable;
      this.selected_time_table_info = null;

      const selectedTimeTable = {
        date: moment(timeTable.start_time).format('YYYY-MM-DD'),
        time: moment(timeTable.start_time).format('HH:mm'),
      }
      const fullTimeTable = this.time_table_groups[selectedTimeTable.date][selectedTimeTable.time];

      if (this.selected_doctor_id === null) {

        /** Get random time table group by selected date & time */
        this.selected_time_table = timeTable = fullTimeTable[Math.floor(Math.random() * fullTimeTable.length)];
      } else {
        const current_doctor_time_table = fullTimeTable.filter((elem) => (elem.doctor_id === this.selected_doctor_id))
        this.selected_time_table = current_doctor_time_table[0] ?? this.selected_time_table_info;
      }

      let clinic = this.clinics.filter((clinic) => {
        return timeTable.clinic_id === clinic.id
      })
      if (clinic) {
        this.selectedClinic = clinic[0]
      }

      if (this.selectedDiagnostic) {
        // this.seanceLoading = true
        let res = await getSettings();
        await this.$store.dispatch('getSettings', res)
        this.$store
            .dispatch('getTimeTableInfo', {
              timetable_id: timeTable.id,
              service_id: timeTable.service_id,
            })
            .then(timeTableInfo => {

              this.selected_time_table_info = timeTableInfo;
              if (timeTableInfo.service_prepare_info_id && showPrepareInfo) {
                // this.openInfoModal()
              } else {
                // this.seanceLoading = false
              }
            })
      }
    },


    getTimeTableByDoctor(value) {
      if (value) {
        let filteredByDoctor = {}
        for (let date in this.time_table_groups) {
          for (let time in this.time_table_groups[date]) {
            for (let idx in this.time_table_groups[date][time]) {
              if (this.time_table_groups[date][time][idx].doctor_id === value) {
                if (!filteredByDoctor[date]) filteredByDoctor[date] = {}
                if (!filteredByDoctor[date][time]) filteredByDoctor[date][time] = {}
                filteredByDoctor[date][time] = this.time_table_groups[date][time]
              }
            }

          }
        }
        return filteredByDoctor
      }

      return this.time_table_groups
    },
    fetch() {
      let query = {
        start_at: moment().format(config.DATE_FORMAT),
        end_at: moment().add(1, 'years').format(config.DATE_FORMAT),
      };

      if (this.diagnostic_type_id) {
        query = {
          ...query,
          service_type: 'diagnostic',
          service_type_id: this.diagnostic_id,
        };
      }

      if (this.clinic_id) {
        query = {
          ...query,
          clinic_id: this.clinic_id,
        };
      }

      if (!this.diagnostic_id) {
        if (this.guest) {
          return this.$router.push({
            name: 'order.order-choose-diagnostic',
            query,
          });
        } else {
          return this.$router.push({
            name: 'profile.order.order-choose-diagnostic',
            query,
          });
        }
      }

      if (!this.diagnostic_type_id) {
        if (this.guest) {
          return this.$router.push({
            name: 'order.find-diagnostic',
            query,
          });
        } else {
          return this.$router.push({
            name: 'profile.order.find-diagnostic',
            query,
          });
        }
      }

      for (let diagnostic of this.diagnostics) {
        if (diagnostic.id === Number.parseInt(this.diagnostic_id)) {
          this.selectedDiagnostic = diagnostic;
          break;
        }
      }

      for (let diagnosticType of this.diagnosticTypes) {
        if (diagnosticType.id === Number.parseInt(this.diagnostic_type_id)) {
          this.selectedDiagnosticType = diagnosticType;
          break;
        }
      }

      for (let clinic of this.clinics) {
        if (clinic.id === Number.parseInt(this.clinic_id)) {
          this.selectedClinic = clinic;
          break;
        }
      }

      query = {
        ...query,
        diagnostic_id: this.diagnostic_id,
      };

      this.$store
          .dispatch('getTimeTables', query)
          .then(({data, meta}) => {
            this.doctor_groups.push({id: null, name: this.$t('diagnostic.all_doctors')})
            this.doctor_groups = this.doctor_groups.concat(meta.doctors);
            this.time_table_groups = data

            this.loading = false;
          });
    }
  },
  computed: {
    ...mapGetters([
      'diagnosticTypes',
      'clinics',
      'diagnostics',
      'doctors',
      'patient',
      'settings'
    ]),
    isReservation() {
      let state = {
        operatorCall: false,
        reservation: false,
      }
      let globalReservation = this.settings.reservation_available
      let serviceReservation = this.selected_time_table_info.can_be_reserved

      if (serviceReservation) {
        if (globalReservation) {
          state.operatorCall = true
        } else {
          state.reservation = true
        }
      }
      return state;
    },
    routerLinkOrderChooseDiagnostic() {
      let query = {};

      if (this.selectedDiagnostic) {
        query = {
          ...query,
          diagnostic_type_id: this.selectedDiagnostic.diagnostic_type_id,
        };
      }

      if (this.selectedClinic) {
        query = {
          ...query,
          clinic_id: this.selectedClinic.id,
        };
      }

      if (this.guest) {
        return {
          name: 'order.choose-diagnostic',
          query,
        };
      } else {
        return {
          name: 'profile.order.choose-diagnostic',
          query,
        };
      }
    },
    disableConfirmButton() {
      return this.selected_time_table === null && this.selected_time_table_info === null;
    }
  },
  async mounted() {
    try {
      if (!this.diagnosticTypes.length) {
        await this.$store.dispatch('getDiagnosticTypes')
      }
      if (!this.diagnostics.length) {
        await this.$store.dispatch('getDiagnostics', {
          diagnostic_type_id: this.diagnostic_type_id,
          clinic_id: this.clinic_id
        })
      }

      await this.fetch()
    } catch (e) {

    }
  },
  components: {
    PrepareInfoModal,
    TimeTableInput,
    OperatorModal
  },
}
</script>

<style lang="scss" scoped>
.doctor-not-found-card {
  max-width: 220px;
  padding: 20px;

  box-shadow: 0 2px 4px -1px rgba(163, 190, 204, 0.5), 0 0 0 1px rgba(163, 190, 204, 0.2);
  border-radius: 5px;

  & .header {
    font-size: 15px;
    font-weight: bold;
    color: #0a4766;
    margin-bottom: 10px;
  }

  & .text {
    max-width: 135px;
    font-size: 12px;
    color: #7c98a6;
    margin-bottom: 15px;
  }

  & .phone {
    font-size: 18px;
    color: #0a4766;
  }
}

.header {
  position: relative;

  & > span {
    position: relative;
    top: -7px;
  }
}

.icon__edit {
  display: inline-block;
  background-repeat: no-repeat;
  margin-left: 10px;
  position: relative;
  top: 3px;
}

.time-table {
  & button {
    width: 120px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
}
</style>
